export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_group.38f3c96d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};